import React, { useState } from 'react';
import classnames from 'classnames';
import { BUTTON_LOADING_CIRCLE } from 'common/utils/constants';
import { DebounceInput } from 'react-debounce-input';
import '../HeatmapRetrieveModal.css';
import { useSelector } from 'react-redux';
import { Status } from 'apis/Status';

const SET_RETRIEVE_TIMEOUT_MESSAGE =
  'The minimum setting for the Retrieve Timeout is 1 minute and ' +
  'the maximum setting for the Retrieve Timeout is 10 minutes. ' +
  'The default setting for the Retrieve Timeout is 2 minutes';

const HeatmapRetrieveSetTimeoutScreen = (props) => {
  return (
    <div id="HeatmapRetrieveModal_Container" className="HeatmapRetrieveModal_Container">
      <div id="HeatmapRetrieveModal_TopContainer" className="HeatmapRetrieveModal_TopContainer">
        <div id="HeatmapRetrieveModal_HeaderText" className="HeatmapRetrieveModal_HeaderText">
          Set Retrieve Timeout
        </div>
        <div
          id="HeatmapRetrieveModal_MessageText"
          className="HeatmapRetrieveModal_MessageText"
          data-tip={SET_RETRIEVE_TIMEOUT_MESSAGE}
        >
          {SET_RETRIEVE_TIMEOUT_MESSAGE}
        </div>

        <div id="HeatmapRetrieveModal_SetTimeout_Box" className="HeatmapRetrieveModal_SetTimeout_Box">
          <DebounceInput
            disabled={props.isFetching}
            onChange={(evt) => {
              let newTimeoutMinute = parseInt(evt.target.value);

              props.setTimeoutMinute(Number.isNaN(newTimeoutMinute) ? 2 : newTimeoutMinute);
            }}
            value={props.timeoutMinute}
            debounceTimeout={500}
            minLength={0}
            forceNotifyByEnter={true}
            forceNotifyOnBlur={true}
            type={'number'}
            onClick={(e) => {
              e.target.select();
            }}
          />
          <span id="HeatmapRetrieveModal_SetTimeout_Title" className="HeatmapRetrieveModal_SetTimeout_Title">
            &nbsp; minutes
          </span>
        </div>
      </div>
      <div id="HeatmapRetrieveModal_BottomContainer" className="HeatmapRetrieveModal_BottomContainer">
        <button
          id="HeatmapRetrieveModal_Bottom_CancelButton"
          className={classnames({
            HeatmapRetrieveModal_Bottom_CancelButton: true
            // HeatmapRetrieveModal_Bottom_CancelButton_Disabled: props.isFetching
          })}
          onClick={() => {
            props.onClose();
          }}
        >
          Cancel
        </button>

        <button
          type="submit"
          disabled={props.isFetching}
          id="HeatmapRetrieveModal_Bottom_ActionButton"
          className={classnames({
            HeatmapRetrieveModal_Bottom_ActionButton: true,
            HeatmapRetrieveModal_Bottom_ActionButton_Disabled:
              props.isFetching || props.timeoutMinute < 1 || props.timeoutMinute > 10
          })}
          onClick={() => {
            props.retrieveHeatmapAction();
          }}
        >
          {props.isFetching ? BUTTON_LOADING_CIRCLE : 'Run Retrieve'}
        </button>
      </div>
    </div>
  );
};

export default React.memo(HeatmapRetrieveSetTimeoutScreen);
